import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';
import { ComingSoonInterestType } from '../../components/payrolladmin/coming-soon-upsell/coming-soon-upsell.types';

export interface ComingSoonInterestEventRecord {
  id: string;
  userId?: string;
  featureKey?: string;
  interestType?: ComingSoonInterestType | string;
  email?: string;
  message?: string;
  eventTimestamp?: string;
  timestampIso?: string;
  context?: Record<string, any>;
  metadata?: Record<string, any>;
  createdAt?: string;
}

export interface CreateComingSoonInterestEventBody {
  userId?: string;
  featureKey: string;
  interestType: ComingSoonInterestType;
  email?: string;
  message?: string;
  eventTimestamp: string;
  timestampIso: string;
  context?: Record<string, any>;
  metadata?: Record<string, any>;
}

@Injectable({
  providedIn: 'root',
})
export class ComingSoonInterestEventsService {
  constructor(private restangular: ApiClient) {}

  getAll(): Promise<ComingSoonInterestEventRecord[]> {
    return this.restangular.one('comingSoonInterestEvents').getList().toPromise() as Promise<ComingSoonInterestEventRecord[]>;
  }

  getById(id: string): Promise<ComingSoonInterestEventRecord> {
    return this.restangular.one('comingSoonInterestEvents', id).get().toPromise() as Promise<ComingSoonInterestEventRecord>;
  }

  create(body: CreateComingSoonInterestEventBody): Promise<ComingSoonInterestEventRecord> {
    return this.restangular.one('comingSoonInterestEvents').customPOST(body).toPromise() as Promise<ComingSoonInterestEventRecord>;
  }

  patchById(id: string, body: Partial<CreateComingSoonInterestEventBody>): Promise<ComingSoonInterestEventRecord> {
    return this.restangular.one('comingSoonInterestEvents', id).customPATCH(body).toPromise() as Promise<ComingSoonInterestEventRecord>;
  }

  putById(id: string, body: Partial<CreateComingSoonInterestEventBody>): Promise<ComingSoonInterestEventRecord> {
    return this.restangular.one('comingSoonInterestEvents', id).customPUT(body).toPromise() as Promise<ComingSoonInterestEventRecord>;
  }

  deleteById(id: string): Promise<ComingSoonInterestEventRecord> {
    return this.restangular.one('comingSoonInterestEvents', id).customDELETE().toPromise() as Promise<ComingSoonInterestEventRecord>;
  }
}
